import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.logo-marquee__splide' ).length ) {
        $( '.logo-marquee__splide' ).each( function( _index, element ) {
          const $section = $( element ).closest( '[data-component="logo-marquee"]' );
          const $btn = $section.find( '.js-marquee-toggle' );

          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            perPage: 1,
            gap: '80px',
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );

          $btn.on( 'click', function() {
            if ( $( this ).hasClass( 'is-paused' ) ) {
              slider.Components.AutoScroll.play();
              $( this ).removeClass( 'is-paused' ).attr( 'title', 'Pause marquee' );
            } else {
              slider.Components.AutoScroll.pause();
              $( this ).addClass( 'is-paused' ).attr( 'title', 'Play marquee' );
            }
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
